// The design-partner form posts to FormSubmit, which delivers to one address
// per request, so each recipient needs its own call.
const ENDPOINT = 'https://formsubmit.co/ajax/';

const RECIPIENTS = [
  'jeff@getbrandbase.com',
  'cary@sproutai.com',
  'mark@sproutai.com',
  'carson@sproutai.com',
];

/**
 * Fire-and-forget: the form already shows its confirmation optimistically, so a
 * failed delivery must not surface as an unhandled rejection.
 */
export function submitInquiry({ name, company, email, message }) {
  const payload = JSON.stringify({
    _subject: 'New BrandBase design partner inquiry',
    Name: name,
    Company: company,
    Email: email,
    Message: message,
  });

  for (const to of RECIPIENTS) {
    fetch(ENDPOINT + to, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: payload,
    }).catch(() => {});
  }
}
